<template>
    <div>
        <FilterTable 
          :resource_name="resource_name"
          :title="title"
          :field_definitions="field_definitions"
          :filters="filters"
          :action_buttons="action_buttons"
          :row_actions="row_actions"
          :translate_to_display_data="translate_to_display_data"
          :route_root="route_root"
          :handle_row_action="handle_row_action"
          :full_text_search="true"
        />
    </div>
</template>

<script>
// @ is an alias to /src
//import Main from '@/components/backstage/Main.vue'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

  export default {
    mixins: [breadcrumbMixin],
    components: {
      FilterTable,
    },
    created () {
      this.permission_check({
        resource_info: { name: this.page_name.PAGE_ISSUE_REPORT_MANAGEMENT },
        access: { name: this.permission.VIEW },
        reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
      })
    },
    data() {
      return {
        resource_name: 'issue-report',
        title: '問題回報管理',
        route_root: 'system-management/issue-report',
        field_definitions: [
          {
            display: {
              name: '編號',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'id',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '問題類型',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'type',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '回報內容',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'content',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '回報者',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'username',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '回報時間',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'created_time',
              data_type: 'datetime',
            } 
          },
          {
            display: {
              name: '狀態',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'status',
              data_type: 'string',
            } 
          }          
        ],
        filters: {
          '問題狀態': {
            paramName: 'status',
            value: null,
            options: {
                type: 'fixed',
                list: ['已處理', '未處理', '處理中'].map(value => { return {value: value, label: value} }),
            }
          }
        },
        action_buttons: {
        },
        row_actions: {
          get: {
            label: '回覆',
            action: 'get'
          }
        },
      }
    },
    methods:{
      handle_row_action (action, index, row) {
        console.log('issueReport: action:' + action + ', index: ' + index + ', row: ', row)

          switch(action){
            case 'get': 
                this.backstage_router_push({ path: `/${this.route_root}/edit/${row.id}` })
                break
            default:
                break
          }
      }
    }
  };
</script>

